module.exports = __webpack_public_path__ + "assets/images/vcr_officeBuilding-03.d8d670e0288a64d3c353096ff9e7f481.svg";